import React from 'react';

import { AdjustedPaymentTermSimulationModal } from './adjustedPaymentTermSimulation';
import { AdjustedSimulationModal } from './adjustedSimulation';
import { AutoSimulateModal } from './autoSimulate/autoSimulate';
import { GenericErrorModal } from './genericError';
import { NoValidSimulationModal } from './noValidSimulation';
import { ShareYourSimulation } from './shareYourSimulation/shareYourSimulation';
import { UserIsClientModal } from './userIsClient';

export const AppModals: React.FC = () => {
	return (
		<>
			<GenericErrorModal />
			<NoValidSimulationModal />
			<AdjustedSimulationModal />
			<AutoSimulateModal />
			<AdjustedPaymentTermSimulationModal />
			<UserIsClientModal />
			<ShareYourSimulation />
		</>
	);
};
